export const ETH_NO_ACCOUNTS =
  'web3 accounts not found. Do you have MetaMask installed and unlocked?'
